import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { Subject, throwError } from 'rxjs';
import { catchError, takeUntil, takeWhile } from 'rxjs/operators';
import { UserData } from 'src/app/providers/user-data';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { SettingsService } from 'src/app/services/settings.service';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-user',
  templateUrl: './login-user.page.html',
  styleUrls: ['./login-user.page.scss'],
})
export class LoginUserPage implements OnInit, OnDestroy {
  usePassword: boolean;

  public loginFormGroup = this.formBuilder.group({
    email: ['', Validators.email],
    password: [''],
    usePassword: [false]
  });

  email = '';
  usePwd = false;
  password = '';
  submitted = false;
  showMessage = false;
  loading = false;
  count: number;
  public clientVersion: string;

  message: {
    status: boolean;
    text: string;
  };


  onDestroy = new Subject();
  company: any;
  colors: any[];

  constructor(
    public userData: UserData,
    public router: Router,
    private authService: AuthService,
    public settingsService: SettingsService,
    private storageService: StorageService,
    private companyService: CompanyService,
    private formBuilder: FormBuilder,
    private storage: Storage
  ) {
    this.authService.authenticationState.subscribe(res => {
      if (res === true) {
        this.router.navigate(["folder/Kalender"])
      }
    })
  }

  ngOnInit() {
    this.clientVersion = this.settingsService.getClientVersion();
    console.log(this.clientVersion);
    this.settingsService
      .isServerAvailable()
      .pipe(
        catchError(err => {
          if (err.name === 'TimeoutError') {
            this.message = {
              status: false,
              text: 'settings.server_not_reachable'
            };
          }
          return throwError(err);
        })
      )
      .subscribe(_ => {

      });
    // this.companyService.getCompanyById(this.company._id).subscribe(async res => {
    //   this.company = res;
    //   await this.storage.set(environment.storage.company, res);
    //   if (this.company) {
    //     this.colors = [this.company.primary_color, this.company.secondary_color]
    //     let root = document.documentElement;
    //     if (this.colors[0] != undefined) {
    //       root.style.setProperty('--ion-color-primary', this.colors[0]);
    //     } else {
    //       root.style.setProperty('--ion-color-primary', 'grey');
    //     }
    //     if (this.colors[1] != undefined) {
    //       root.style.setProperty('--ion-color-secondary', this.colors[1]);
    //     } else {
    //       root.style.setProperty('--ion-color-secondary', 'goldenrod');
    //     }
    //   }
    // })

  }



  checkPW(event) {
    // this.usePwd = !this.usePwd
    // console.log('Event: ', event.target.value);
    // console.log('uswPW: ', this.usePwd);

    this.storageService.set('usePW', this.loginFormGroup.get('usePassword').value);
    // this.usePwd = event;
  }


  ionViewWillEnter() {
    console.log("ionviewwillenter")
    this.storageService.get('usePW').then(usePassword => {
      this.loginFormGroup.get('usePassword').setValue(usePassword);
    });
    this.authService.checkToken();

  }
  onLogin() {
    // this.count = 180;
    // this.loading = true;
    // this.message = undefined;
    // this.usePassword = false;
    this.message = {
      status: true,
      // text: 'login.check_email'
      text: 'Wir senden Ihnen gerade eine Bestätigungsmail'
    };

    // if (!this.usePassword) {
    //   this.loginWithEmail();
    // } else {
    //   this.loginWithEmailAndPassword();
    // }
    // this.showMessage = true;

    this.count = 180;
    this.loading = true;
    // this.message = undefined;
    if (!this.loginFormGroup.get('usePassword').value) {
      this.authService
        .loginWithEmail(this.loginFormGroup.get('email').value.toLowerCase(), 'event')
        .pipe(
          takeWhile(({ result }) => {
            if (result === true) {
              console.log('Login successful!');
              // this.count = 0;
              this.router.navigate(['folder/Kalender']);
            }
            return result === false && this.count > 0;
          }),
          takeUntil(this.onDestroy)
        )
        .subscribe(
          ({ result }) => {
            this.message = {
              status: true,
              // text: 'login.check_email'
              text: 'Bitte überprüfen sie ihr Email-Postfach'
            };
          },
          error => {
            this.loading = false;
            this.message = {
              status: false,
              // TODO:error message Schrott
              text: error.error.message
            };
          },
          () => {
            this.message = {
              status: true,
              // text: 'login.timeout'
              text: 'Timeout erreicht. Bitte versuchen Sie erneut, sich anzumelden'
            };
            this.loading = false;
            setTimeout(() => {
              this.message = {
                status: true,
                text: undefined
              };
            }, 5000);
          }
        );
    } else {
      this.authService.loginWithPassword(this.loginFormGroup.get('email').value, this.loginFormGroup.get('password').value).subscribe(
        () => {
          this.loading = false;
          this.message = {
            status: true,
            // text: 'login.check_email'
            text: 'Bitte überprüfen sie ihr Email-Postfach'
          };
        },
        error => {
          this.loading = false;
          this.message = {
            status: false,
            text: error.error.message
          };
        }
      );
    }
    this.showMessage = true;
  }

  onCountChange(event) {
    this.count = event;
  }

  onEmailChange(event) {
    this.email = event.toLowerCase();
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
  }

  // private loginWithEmail() {
  //   this.authService
  //     .loginWithEmail(this.email.toLowerCase())
  //     .pipe(
  //       takeWhile(({ result }) => {
  //         if (result === true) {
  //           console.log('Login successful!');
  //           this.router.navigate(['Scheduler']);
  //           // this.router.navigate(['folder/Kalender']);
  //         }

  //         return result === false && this.count > 0;
  //       }),
  //       takeUntil(this.onDestroy)
  //     )
  //     .subscribe(
  //       ({ result }) => {
  //         console.log('Resultat: ', result);
  //         this.loading = false;
  //         this.message = {
  //           status: true,
  //           text: 'Bitte überprüfen sie ihr Email-Postfach'
  //         };
  //       },
  //       error => {
  //         this.loading = false;
  //         this.message = {
  //           status: false,
  //           text: error.error.message
  //         };
  //       },
  //       () => {
  //         this.message = {
  //           status: true,
  //           text: 'Timeout erreicht. Bitte versuchen Sie erneut, sich anzumelden'
  //         };
  //         setTimeout(() => {
  //           this.message = {
  //             status: true,
  //             text: undefined
  //           };
  //         }, 5000);
  //       }
  //     );
  // }

  // private loginWithEmailAndPassword() {
  //   this.authService.loginWithPassword(this.email, this.password).subscribe(
  //     () => {
  //       this.loading = false;
  //       this.message = {
  //         status: true,
  //         text: 'Bitte überprüfen sie ihr Email-Postfach'
  //       };
  //     },
  //     error => {
  //       this.loading = false;
  //       this.message = {
  //         status: false,
  //         text: error.error.message
  //       };
  //     }
  //   );
  // }
}
